import { Rive } from "@rive-app/canvas";
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

if($('#footer-canvas').length) {
  const footerSrc = $('#footer-canvas').data('src')

  const r = new Rive({
    src: footerSrc,
    canvas: document.getElementById("footer-canvas"),
    stateMachines: "State Machine 1",
    autoplay: true,
    loop: true,
    onLoad: () => {
      r.resizeDrawingSurfaceToCanvas();
    }
  })
}


if($('#about-canvas').length) {
  const aboutSrc = $('#about-canvas').data('src')

  const r2 = new Rive({
    src: aboutSrc,
    canvas: document.getElementById("about-canvas"),
    stateMachines: "State Machine 1",
    autoplay: true,
    loop: true,
    onLoad: () => {
      r2.resizeDrawingSurfaceToCanvas();
    }
  });
}


if($('#hero-canvas').length) {
  const heroSrc = $('#hero-canvas').data('src')

  const r3 = new Rive({
    src: heroSrc,
    canvas: document.getElementById("hero-canvas"),
    stateMachines: "State Machine 1",
    autoplay: true,
    loop: true,
    onLoad: () => {
      r3.resizeDrawingSurfaceToCanvas();
    }
  })
}

